import { Pipe, PipeTransform } from '@angular/core';
import { numberSeparator } from '../../utils/number-separator';
import { round } from '../../utils/round';

@Pipe({
  name: 'numberFormatter',
  standalone: false
})
export class NumberFormatterPipe implements PipeTransform {
  public transform(
    value: number | null | undefined,
    pointValue?: number
  ): string {
    if (value) {
      return numberSeparator(round(value, pointValue));
    }
    return round(0, pointValue);
  }
}
